/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrowserDeployment } from '../models/BrowserDeployment';
import type { BrowserDeploymentPostIn } from '../models/BrowserDeploymentPostIn';
import type { BrowserDeploymentTokenOut } from '../models/BrowserDeploymentTokenOut';
import type { BrowserDeploymentUpdateIn } from '../models/BrowserDeploymentUpdateIn';
import type { BrowserLastUsage } from '../models/BrowserLastUsage';
import type { DashboardOverview } from '../models/DashboardOverview';
import type { PaginationSortOrder } from '../models/PaginationSortOrder';
import type { UsageStats } from '../models/UsageStats';
import type { UsageStatsDetails } from '../models/UsageStatsDetails';
import type { UsageStatsWithEmail } from '../models/UsageStatsWithEmail';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrowserExtensionManagementService {
    /**
     * Get Installation Usage Stats
     * Get usage statistics for a specific person (installation_id).
     * @returns UsageStatsDetails Successful Response
     * @throws ApiError
     */
    public static getInstallationUsageStatsApiV1BrowserStatisticsInstallationsInstallationIdGet({
        installationId,
        deploymentId,
        fromDate,
        tillDate,
        xTransactionId,
    }: {
        installationId: string,
        deploymentId?: (string | null),
        fromDate?: (string | null),
        tillDate?: (string | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<UsageStatsDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/statistics/installations/{installation_id}',
            path: {
                'installation_id': installationId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'deployment_id': deploymentId,
                'from_date': fromDate,
                'till_date': tillDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Tool Usage Stats
     * Get usage statistics for a specific tool (software_name).
     * @returns UsageStatsDetails Successful Response
     * @throws ApiError
     */
    public static getToolUsageStatsApiV1BrowserStatisticsToolsSoftwareNameGet({
        softwareName,
        installationId,
        deploymentId,
        fromDate,
        tillDate,
        xTransactionId,
    }: {
        softwareName: string,
        installationId?: (string | null),
        deploymentId?: (string | null),
        fromDate?: (string | null),
        tillDate?: (string | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<UsageStatsDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/statistics/tools/{software_name}',
            path: {
                'software_name': softwareName,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'installation_id': installationId,
                'deployment_id': deploymentId,
                'from_date': fromDate,
                'till_date': tillDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Deployment Usage Stats
     * Get usage statistics for a specific deployment.
     * @returns UsageStatsDetails Successful Response
     * @throws ApiError
     */
    public static getDeploymentUsageStatsApiV1BrowserStatisticsDeploymentsDeploymentIdGet({
        deploymentId,
        fromDate,
        tillDate,
        xTransactionId,
    }: {
        deploymentId: string,
        fromDate?: (string | null),
        tillDate?: (string | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<UsageStatsDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/statistics/deployments/{deployment_id}',
            path: {
                'deployment_id': deploymentId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'from_date': fromDate,
                'till_date': tillDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Installations Stats
     * Get usage statistics for all installations.
     * @returns UsageStatsWithEmail Successful Response
     * @throws ApiError
     */
    public static getAllInstallationsStatsApiV1BrowserStatisticsInstallationsGet({
        deploymentId,
        fromDate,
        tillDate,
        xTransactionId,
    }: {
        deploymentId?: (string | null),
        fromDate?: (string | null),
        tillDate?: (string | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<Array<UsageStatsWithEmail>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/statistics/installations',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'deployment_id': deploymentId,
                'from_date': fromDate,
                'till_date': tillDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Tools Stats
     * Get usage statistics for all tools.
     * @returns UsageStats Successful Response
     * @throws ApiError
     */
    public static getAllToolsStatsApiV1BrowserStatisticsToolsGet({
        deploymentId,
        fromDate,
        tillDate,
        xTransactionId,
    }: {
        deploymentId?: (string | null),
        fromDate?: (string | null),
        tillDate?: (string | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<Array<UsageStats>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/statistics/tools',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'deployment_id': deploymentId,
                'from_date': fromDate,
                'till_date': tillDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Dashboard Overview
     * Get high-level dashboard metrics for the browser extension.
     * @returns DashboardOverview Successful Response
     * @throws ApiError
     */
    public static getDashboardOverviewApiV1BrowserAnalyticsDashboardGet({
        deploymentId,
        fromDate,
        tillDate,
        xTransactionId,
    }: {
        deploymentId?: (string | null),
        fromDate?: (string | null),
        tillDate?: (string | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<DashboardOverview> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/analytics/dashboard',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'deployment_id': deploymentId,
                'from_date': fromDate,
                'till_date': tillDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Browser Deployments
     * @returns BrowserDeployment Successful Response
     * @throws ApiError
     */
    public static getBrowserDeploymentsApiV1BrowserDeploymentsGet({
        createdExists,
        createdEq,
        createdGt,
        createdGte,
        createdIn,
        createdLt,
        createdLte,
        createdNe,
        createdNin,
        created,
        updatedExists,
        updatedEq,
        updatedGt,
        updatedGte,
        updatedIn,
        updatedLt,
        updatedLte,
        updatedNe,
        updatedNin,
        updated,
        deleted,
        deletedAtExists,
        deletedAtEq,
        deletedAtGt,
        deletedAtGte,
        deletedAtIn,
        deletedAtLt,
        deletedAtLte,
        deletedAtNe,
        deletedAtNin,
        deletedAt,
        includeDeleted = false,
        idExists,
        idEq,
        idGt,
        idGte,
        idIn,
        idLt,
        idLte,
        idNe,
        idNin,
        id,
        nameExists,
        nameEq,
        nameGt,
        nameGte,
        nameIn,
        nameLt,
        nameLte,
        nameNe,
        nameNin,
        name,
        descriptionExists,
        descriptionEq,
        descriptionGt,
        descriptionGte,
        descriptionIn,
        descriptionLt,
        descriptionLte,
        descriptionNe,
        descriptionNin,
        description,
        limit,
        offset,
        sortBy,
        sortOrder,
        sort,
        xTransactionId,
    }: {
        createdExists?: (boolean | null),
        createdEq?: (string | null),
        createdGt?: (string | null),
        createdGte?: (string | null),
        createdIn?: (Array<string> | null),
        createdLt?: (string | null),
        createdLte?: (string | null),
        createdNe?: (string | null),
        createdNin?: (Array<string> | null),
        created?: (string | null),
        updatedExists?: (boolean | null),
        updatedEq?: (string | null),
        updatedGt?: (string | null),
        updatedGte?: (string | null),
        updatedIn?: (Array<string> | null),
        updatedLt?: (string | null),
        updatedLte?: (string | null),
        updatedNe?: (string | null),
        updatedNin?: (Array<string> | null),
        updated?: (string | null),
        deleted?: (boolean | null),
        deletedAtExists?: (boolean | null),
        deletedAtEq?: (string | null),
        deletedAtGt?: (string | null),
        deletedAtGte?: (string | null),
        deletedAtIn?: (Array<string> | null),
        deletedAtLt?: (string | null),
        deletedAtLte?: (string | null),
        deletedAtNe?: (string | null),
        deletedAtNin?: (Array<string> | null),
        deletedAt?: (string | null),
        includeDeleted?: boolean,
        idExists?: (boolean | null),
        idEq?: (string | null),
        idGt?: (string | null),
        idGte?: (string | null),
        idIn?: (Array<string> | null),
        idLt?: (string | null),
        idLte?: (string | null),
        idNe?: (string | null),
        idNin?: (Array<string> | null),
        id?: (string | null),
        nameExists?: (boolean | null),
        nameEq?: (string | null),
        nameGt?: (string | null),
        nameGte?: (string | null),
        nameIn?: (Array<string> | null),
        nameLt?: (string | null),
        nameLte?: (string | null),
        nameNe?: (string | null),
        nameNin?: (Array<string> | null),
        name?: (string | null),
        descriptionExists?: (boolean | null),
        descriptionEq?: (string | null),
        descriptionGt?: (string | null),
        descriptionGte?: (string | null),
        descriptionIn?: (Array<string> | null),
        descriptionLt?: (string | null),
        descriptionLte?: (string | null),
        descriptionNe?: (string | null),
        descriptionNin?: (Array<string> | null),
        description?: (string | null),
        limit?: (number | null),
        offset?: (number | null),
        /**
         * Field name to be sorted by. Ignored if 'sort' is specified
         */
        sortBy?: (string | null),
        /**
         * Sort order to be sorted by. Ignored if 'sort' is specified
         */
        sortOrder?: (PaginationSortOrder | null),
        /**
         * Sort field in the form `<field_name>:<sort_by>`. Example: `sort=email:asc`. If at least one is set, sort_by and sort_order are ignored
         */
        sort?: (Array<string> | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<Array<BrowserDeployment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/deployments',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'created.$exists': createdExists,
                'created.$eq': createdEq,
                'created.$gt': createdGt,
                'created.$gte': createdGte,
                'created.$in': createdIn,
                'created.$lt': createdLt,
                'created.$lte': createdLte,
                'created.$ne': createdNe,
                'created.$nin': createdNin,
                'created': created,
                'updated.$exists': updatedExists,
                'updated.$eq': updatedEq,
                'updated.$gt': updatedGt,
                'updated.$gte': updatedGte,
                'updated.$in': updatedIn,
                'updated.$lt': updatedLt,
                'updated.$lte': updatedLte,
                'updated.$ne': updatedNe,
                'updated.$nin': updatedNin,
                'updated': updated,
                'deleted': deleted,
                'deleted_at.$exists': deletedAtExists,
                'deleted_at.$eq': deletedAtEq,
                'deleted_at.$gt': deletedAtGt,
                'deleted_at.$gte': deletedAtGte,
                'deleted_at.$in': deletedAtIn,
                'deleted_at.$lt': deletedAtLt,
                'deleted_at.$lte': deletedAtLte,
                'deleted_at.$ne': deletedAtNe,
                'deleted_at.$nin': deletedAtNin,
                'deleted_at': deletedAt,
                'include_deleted': includeDeleted,
                '_id.$exists': idExists,
                '_id.$eq': idEq,
                '_id.$gt': idGt,
                '_id.$gte': idGte,
                '_id.$in': idIn,
                '_id.$lt': idLt,
                '_id.$lte': idLte,
                '_id.$ne': idNe,
                '_id.$nin': idNin,
                '_id': id,
                'name.$exists': nameExists,
                'name.$eq': nameEq,
                'name.$gt': nameGt,
                'name.$gte': nameGte,
                'name.$in': nameIn,
                'name.$lt': nameLt,
                'name.$lte': nameLte,
                'name.$ne': nameNe,
                'name.$nin': nameNin,
                'name': name,
                'description.$exists': descriptionExists,
                'description.$eq': descriptionEq,
                'description.$gt': descriptionGt,
                'description.$gte': descriptionGte,
                'description.$in': descriptionIn,
                'description.$lt': descriptionLt,
                'description.$lte': descriptionLte,
                'description.$ne': descriptionNe,
                'description.$nin': descriptionNin,
                'description': description,
                'limit': limit,
                'offset': offset,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'sort': sort,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Browser Deployment
     * @returns BrowserDeployment Successful Response
     * @throws ApiError
     */
    public static createBrowserDeploymentApiV1BrowserDeploymentsPost({
        requestBody,
        xTransactionId,
    }: {
        requestBody: BrowserDeploymentPostIn,
        xTransactionId?: (string | null),
    }): CancelablePromise<BrowserDeployment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/browser/deployments',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Count Browser Deployment
     * @returns number Successful Response
     * @throws ApiError
     */
    public static countBrowserDeploymentApiV1BrowserDeploymentsCountGet({
        createdExists,
        createdEq,
        createdGt,
        createdGte,
        createdIn,
        createdLt,
        createdLte,
        createdNe,
        createdNin,
        created,
        updatedExists,
        updatedEq,
        updatedGt,
        updatedGte,
        updatedIn,
        updatedLt,
        updatedLte,
        updatedNe,
        updatedNin,
        updated,
        deleted,
        deletedAtExists,
        deletedAtEq,
        deletedAtGt,
        deletedAtGte,
        deletedAtIn,
        deletedAtLt,
        deletedAtLte,
        deletedAtNe,
        deletedAtNin,
        deletedAt,
        includeDeleted = false,
        idExists,
        idEq,
        idGt,
        idGte,
        idIn,
        idLt,
        idLte,
        idNe,
        idNin,
        id,
        nameExists,
        nameEq,
        nameGt,
        nameGte,
        nameIn,
        nameLt,
        nameLte,
        nameNe,
        nameNin,
        name,
        descriptionExists,
        descriptionEq,
        descriptionGt,
        descriptionGte,
        descriptionIn,
        descriptionLt,
        descriptionLte,
        descriptionNe,
        descriptionNin,
        description,
        xTransactionId,
    }: {
        createdExists?: (boolean | null),
        createdEq?: (string | null),
        createdGt?: (string | null),
        createdGte?: (string | null),
        createdIn?: (Array<string> | null),
        createdLt?: (string | null),
        createdLte?: (string | null),
        createdNe?: (string | null),
        createdNin?: (Array<string> | null),
        created?: (string | null),
        updatedExists?: (boolean | null),
        updatedEq?: (string | null),
        updatedGt?: (string | null),
        updatedGte?: (string | null),
        updatedIn?: (Array<string> | null),
        updatedLt?: (string | null),
        updatedLte?: (string | null),
        updatedNe?: (string | null),
        updatedNin?: (Array<string> | null),
        updated?: (string | null),
        deleted?: (boolean | null),
        deletedAtExists?: (boolean | null),
        deletedAtEq?: (string | null),
        deletedAtGt?: (string | null),
        deletedAtGte?: (string | null),
        deletedAtIn?: (Array<string> | null),
        deletedAtLt?: (string | null),
        deletedAtLte?: (string | null),
        deletedAtNe?: (string | null),
        deletedAtNin?: (Array<string> | null),
        deletedAt?: (string | null),
        includeDeleted?: boolean,
        idExists?: (boolean | null),
        idEq?: (string | null),
        idGt?: (string | null),
        idGte?: (string | null),
        idIn?: (Array<string> | null),
        idLt?: (string | null),
        idLte?: (string | null),
        idNe?: (string | null),
        idNin?: (Array<string> | null),
        id?: (string | null),
        nameExists?: (boolean | null),
        nameEq?: (string | null),
        nameGt?: (string | null),
        nameGte?: (string | null),
        nameIn?: (Array<string> | null),
        nameLt?: (string | null),
        nameLte?: (string | null),
        nameNe?: (string | null),
        nameNin?: (Array<string> | null),
        name?: (string | null),
        descriptionExists?: (boolean | null),
        descriptionEq?: (string | null),
        descriptionGt?: (string | null),
        descriptionGte?: (string | null),
        descriptionIn?: (Array<string> | null),
        descriptionLt?: (string | null),
        descriptionLte?: (string | null),
        descriptionNe?: (string | null),
        descriptionNin?: (Array<string> | null),
        description?: (string | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/deployments/count',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'created.$exists': createdExists,
                'created.$eq': createdEq,
                'created.$gt': createdGt,
                'created.$gte': createdGte,
                'created.$in': createdIn,
                'created.$lt': createdLt,
                'created.$lte': createdLte,
                'created.$ne': createdNe,
                'created.$nin': createdNin,
                'created': created,
                'updated.$exists': updatedExists,
                'updated.$eq': updatedEq,
                'updated.$gt': updatedGt,
                'updated.$gte': updatedGte,
                'updated.$in': updatedIn,
                'updated.$lt': updatedLt,
                'updated.$lte': updatedLte,
                'updated.$ne': updatedNe,
                'updated.$nin': updatedNin,
                'updated': updated,
                'deleted': deleted,
                'deleted_at.$exists': deletedAtExists,
                'deleted_at.$eq': deletedAtEq,
                'deleted_at.$gt': deletedAtGt,
                'deleted_at.$gte': deletedAtGte,
                'deleted_at.$in': deletedAtIn,
                'deleted_at.$lt': deletedAtLt,
                'deleted_at.$lte': deletedAtLte,
                'deleted_at.$ne': deletedAtNe,
                'deleted_at.$nin': deletedAtNin,
                'deleted_at': deletedAt,
                'include_deleted': includeDeleted,
                '_id.$exists': idExists,
                '_id.$eq': idEq,
                '_id.$gt': idGt,
                '_id.$gte': idGte,
                '_id.$in': idIn,
                '_id.$lt': idLt,
                '_id.$lte': idLte,
                '_id.$ne': idNe,
                '_id.$nin': idNin,
                '_id': id,
                'name.$exists': nameExists,
                'name.$eq': nameEq,
                'name.$gt': nameGt,
                'name.$gte': nameGte,
                'name.$in': nameIn,
                'name.$lt': nameLt,
                'name.$lte': nameLte,
                'name.$ne': nameNe,
                'name.$nin': nameNin,
                'name': name,
                'description.$exists': descriptionExists,
                'description.$eq': descriptionEq,
                'description.$gt': descriptionGt,
                'description.$gte': descriptionGte,
                'description.$in': descriptionIn,
                'description.$lt': descriptionLt,
                'description.$lte': descriptionLte,
                'description.$ne': descriptionNe,
                'description.$nin': descriptionNin,
                'description': description,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Browser Deployment
     * @returns BrowserDeployment Successful Response
     * @throws ApiError
     */
    public static getBrowserDeploymentApiV1BrowserDeploymentsBrowserDeploymentIdGet({
        browserDeploymentId,
        includeDeleted = false,
        xTransactionId,
    }: {
        browserDeploymentId: string,
        includeDeleted?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<BrowserDeployment> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/deployments/{browser_deployment_id}',
            path: {
                'browser_deployment_id': browserDeploymentId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'include_deleted': includeDeleted,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Browser Deployment
     * @returns BrowserDeployment Successful Response
     * @throws ApiError
     */
    public static patchBrowserDeploymentApiV1BrowserDeploymentsBrowserDeploymentIdPatch({
        browserDeploymentId,
        requestBody,
        includeDeleted = false,
        xTransactionId,
    }: {
        browserDeploymentId: string,
        requestBody: BrowserDeploymentUpdateIn,
        includeDeleted?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<BrowserDeployment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/browser/deployments/{browser_deployment_id}',
            path: {
                'browser_deployment_id': browserDeploymentId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'include_deleted': includeDeleted,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Browser Deployment
     * @returns void
     * @throws ApiError
     */
    public static deleteBrowserDeploymentApiV1BrowserDeploymentsBrowserDeploymentIdDelete({
        browserDeploymentId,
        includeDeleted = false,
        xTransactionId,
    }: {
        browserDeploymentId: string,
        includeDeleted?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/browser/deployments/{browser_deployment_id}',
            path: {
                'browser_deployment_id': browserDeploymentId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'include_deleted': includeDeleted,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Browser Deployment Token
     * @returns BrowserDeploymentTokenOut Successful Response
     * @throws ApiError
     */
    public static createBrowserDeploymentTokenApiV1BrowserDeploymentsBrowserDeploymentIdTokenPost({
        browserDeploymentId,
        includeDeleted = false,
        xTransactionId,
    }: {
        browserDeploymentId: string,
        includeDeleted?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<BrowserDeploymentTokenOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/browser/deployments/{browser_deployment_id}/token',
            path: {
                'browser_deployment_id': browserDeploymentId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'include_deleted': includeDeleted,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Browser Last Usages
     * @returns BrowserLastUsage Successful Response
     * @throws ApiError
     */
    public static getBrowserLastUsagesApiV1BrowserLastUsagesGet({
        createdExists,
        createdEq,
        createdGt,
        createdGte,
        createdIn,
        createdLt,
        createdLte,
        createdNe,
        createdNin,
        created,
        updatedExists,
        updatedEq,
        updatedGt,
        updatedGte,
        updatedIn,
        updatedLt,
        updatedLte,
        updatedNe,
        updatedNin,
        updated,
        deleted,
        deletedAtExists,
        deletedAtEq,
        deletedAtGt,
        deletedAtGte,
        deletedAtIn,
        deletedAtLt,
        deletedAtLte,
        deletedAtNe,
        deletedAtNin,
        deletedAt,
        includeDeleted = false,
        idExists,
        idEq,
        idGt,
        idGte,
        idIn,
        idLt,
        idLte,
        idNe,
        idNin,
        id,
        installationIdExists,
        installationIdEq,
        installationIdGt,
        installationIdGte,
        installationIdIn,
        installationIdLt,
        installationIdLte,
        installationIdNe,
        installationIdNin,
        installationId,
        softwareNameExists,
        softwareNameEq,
        softwareNameGt,
        softwareNameGte,
        softwareNameIn,
        softwareNameLt,
        softwareNameLte,
        softwareNameNe,
        softwareNameNin,
        softwareName,
        deploymentIdExists,
        deploymentIdEq,
        deploymentIdGt,
        deploymentIdGte,
        deploymentIdIn,
        deploymentIdLt,
        deploymentIdLte,
        deploymentIdNe,
        deploymentIdNin,
        deploymentId,
        limit,
        offset,
        sortBy,
        sortOrder,
        sort,
        xTransactionId,
    }: {
        createdExists?: (boolean | null),
        createdEq?: (string | null),
        createdGt?: (string | null),
        createdGte?: (string | null),
        createdIn?: (Array<string> | null),
        createdLt?: (string | null),
        createdLte?: (string | null),
        createdNe?: (string | null),
        createdNin?: (Array<string> | null),
        created?: (string | null),
        updatedExists?: (boolean | null),
        updatedEq?: (string | null),
        updatedGt?: (string | null),
        updatedGte?: (string | null),
        updatedIn?: (Array<string> | null),
        updatedLt?: (string | null),
        updatedLte?: (string | null),
        updatedNe?: (string | null),
        updatedNin?: (Array<string> | null),
        updated?: (string | null),
        deleted?: (boolean | null),
        deletedAtExists?: (boolean | null),
        deletedAtEq?: (string | null),
        deletedAtGt?: (string | null),
        deletedAtGte?: (string | null),
        deletedAtIn?: (Array<string> | null),
        deletedAtLt?: (string | null),
        deletedAtLte?: (string | null),
        deletedAtNe?: (string | null),
        deletedAtNin?: (Array<string> | null),
        deletedAt?: (string | null),
        includeDeleted?: boolean,
        idExists?: (boolean | null),
        idEq?: (string | null),
        idGt?: (string | null),
        idGte?: (string | null),
        idIn?: (Array<string> | null),
        idLt?: (string | null),
        idLte?: (string | null),
        idNe?: (string | null),
        idNin?: (Array<string> | null),
        id?: (string | null),
        installationIdExists?: (boolean | null),
        installationIdEq?: (string | null),
        installationIdGt?: (string | null),
        installationIdGte?: (string | null),
        installationIdIn?: (Array<string> | null),
        installationIdLt?: (string | null),
        installationIdLte?: (string | null),
        installationIdNe?: (string | null),
        installationIdNin?: (Array<string> | null),
        installationId?: (string | null),
        softwareNameExists?: (boolean | null),
        softwareNameEq?: (string | null),
        softwareNameGt?: (string | null),
        softwareNameGte?: (string | null),
        softwareNameIn?: (Array<string> | null),
        softwareNameLt?: (string | null),
        softwareNameLte?: (string | null),
        softwareNameNe?: (string | null),
        softwareNameNin?: (Array<string> | null),
        softwareName?: (string | null),
        deploymentIdExists?: (boolean | null),
        deploymentIdEq?: (string | null),
        deploymentIdGt?: (string | null),
        deploymentIdGte?: (string | null),
        deploymentIdIn?: (Array<string> | null),
        deploymentIdLt?: (string | null),
        deploymentIdLte?: (string | null),
        deploymentIdNe?: (string | null),
        deploymentIdNin?: (Array<string> | null),
        deploymentId?: (string | null),
        limit?: (number | null),
        offset?: (number | null),
        /**
         * Field name to be sorted by. Ignored if 'sort' is specified
         */
        sortBy?: (string | null),
        /**
         * Sort order to be sorted by. Ignored if 'sort' is specified
         */
        sortOrder?: (PaginationSortOrder | null),
        /**
         * Sort field in the form `<field_name>:<sort_by>`. Example: `sort=email:asc`. If at least one is set, sort_by and sort_order are ignored
         */
        sort?: (Array<string> | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<Array<BrowserLastUsage>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/browser/last-usages',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'created.$exists': createdExists,
                'created.$eq': createdEq,
                'created.$gt': createdGt,
                'created.$gte': createdGte,
                'created.$in': createdIn,
                'created.$lt': createdLt,
                'created.$lte': createdLte,
                'created.$ne': createdNe,
                'created.$nin': createdNin,
                'created': created,
                'updated.$exists': updatedExists,
                'updated.$eq': updatedEq,
                'updated.$gt': updatedGt,
                'updated.$gte': updatedGte,
                'updated.$in': updatedIn,
                'updated.$lt': updatedLt,
                'updated.$lte': updatedLte,
                'updated.$ne': updatedNe,
                'updated.$nin': updatedNin,
                'updated': updated,
                'deleted': deleted,
                'deleted_at.$exists': deletedAtExists,
                'deleted_at.$eq': deletedAtEq,
                'deleted_at.$gt': deletedAtGt,
                'deleted_at.$gte': deletedAtGte,
                'deleted_at.$in': deletedAtIn,
                'deleted_at.$lt': deletedAtLt,
                'deleted_at.$lte': deletedAtLte,
                'deleted_at.$ne': deletedAtNe,
                'deleted_at.$nin': deletedAtNin,
                'deleted_at': deletedAt,
                'include_deleted': includeDeleted,
                '_id.$exists': idExists,
                '_id.$eq': idEq,
                '_id.$gt': idGt,
                '_id.$gte': idGte,
                '_id.$in': idIn,
                '_id.$lt': idLt,
                '_id.$lte': idLte,
                '_id.$ne': idNe,
                '_id.$nin': idNin,
                '_id': id,
                'installation_id.$exists': installationIdExists,
                'installation_id.$eq': installationIdEq,
                'installation_id.$gt': installationIdGt,
                'installation_id.$gte': installationIdGte,
                'installation_id.$in': installationIdIn,
                'installation_id.$lt': installationIdLt,
                'installation_id.$lte': installationIdLte,
                'installation_id.$ne': installationIdNe,
                'installation_id.$nin': installationIdNin,
                'installation_id': installationId,
                'software_name.$exists': softwareNameExists,
                'software_name.$eq': softwareNameEq,
                'software_name.$gt': softwareNameGt,
                'software_name.$gte': softwareNameGte,
                'software_name.$in': softwareNameIn,
                'software_name.$lt': softwareNameLt,
                'software_name.$lte': softwareNameLte,
                'software_name.$ne': softwareNameNe,
                'software_name.$nin': softwareNameNin,
                'software_name': softwareName,
                'deployment_id.$exists': deploymentIdExists,
                'deployment_id.$eq': deploymentIdEq,
                'deployment_id.$gt': deploymentIdGt,
                'deployment_id.$gte': deploymentIdGte,
                'deployment_id.$in': deploymentIdIn,
                'deployment_id.$lt': deploymentIdLt,
                'deployment_id.$lte': deploymentIdLte,
                'deployment_id.$ne': deploymentIdNe,
                'deployment_id.$nin': deploymentIdNin,
                'deployment_id': deploymentId,
                'limit': limit,
                'offset': offset,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'sort': sort,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
